export default __webpack_public_path__ + "static/media/stomach_plot_female.ef324141.png";